import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_SAMPLE_COLLECTORS } from "../../config/connString";
import useAxios from "../../utils/useAxios";
import decodedUserDetails from "utils/decodedUserDetails";

const createSampleCollector = createAsyncThunk(
  "sample-collectors/create-sample-collector",
  async (data) => {
    try {
      const clientId = decodedUserDetails()?.clientId;
      const api = useAxios();
      const isProjectLocationJkt =
        process.env.REACT_APP_COUNTRY.toLowerCase() === "jkt";

      const response = await api.post(URL_SAMPLE_COLLECTORS, {
        licenseNumber: null,
        licenseExpirationDate: isProjectLocationJkt
          ? null
          : data.licenseExpirationDate,
        firstName: data.firstName,
        lastName: data.lastName,
        collectorType: data.collectorType,
        clientId: clientId,
        phoneNumber: isProjectLocationJkt ? null : data.phoneNumber,
        email: isProjectLocationJkt ? null : data.email,
        isActive: true,
      });
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export { createSampleCollector };
